export const validateReductionValue = (value: number | null | undefined, isPercent: boolean): boolean => {
  if (value == null) return false
  const num = Number(value)
  if (!Number.isFinite(num) || num <= 0) return false
  if (isPercent && num > 100) return false
  return true
}

export const validateMinAmount = (amount: number | null | undefined): boolean => {
  return amount != null && amount > 0
}

export const validateCartItemCount = (count: number | null | undefined): boolean => {
  return count != null && count > 0
}

export const validateXForYBuyQuantity = (value: number | null | undefined): boolean => {
  if (value == null) return false
  const num = Number(value)
  return Number.isFinite(num) && num > 0 && Number.isInteger(num)
}

export const validateXForYFreeQuantity = (value: number | null | undefined): boolean => {
  if (value == null) return false
  const num = Number(value)
  return Number.isFinite(num) && num > 0 && Number.isInteger(num)
}

export const validateUsageLimitQuantity = (quantity: number | null | undefined): boolean => {
  return quantity != null && quantity > 0
}
